import { useState } from 'react';
import { Link, Navigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { supabase } from '@/lib/supabase';
import { useSession } from '@/hooks/useSession';
import { memoriserEspace } from '@/hooks/useMembre';

export function LoginPage() {
  const { session } = useSession();
  const [email, setEmail] = useState('');
  const [mdp, setMdp] = useState('');
  const [envoi, setEnvoi] = useState(false);
  const [params] = useSearchParams();
  const p = params.get('profil');
  const profil = p === 'assistant' || p === 'admin' ? p : 'expert';
  if (session) return <Navigate to="/espace" replace />;

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <Card className="w-full max-w-sm">
        <CardHeader><CardTitle className="text-xl">Les Experts</CardTitle><CardDescription>{profil === 'admin' ? 'Administration' : `Espace ${profil === 'assistant' ? 'Assistant' : 'Expert'}`} — connexion · <Link to="/" className="underline">changer</Link></CardDescription></CardHeader>
        <CardContent>
          <form className="space-y-3" onSubmit={async (e) => {
            e.preventDefault();
            setEnvoi(true);
            memoriserEspace(profil);
            // Identifiant court (ex. « admin ») = e-mail technique du cabinet
            const ident = email.trim().toLowerCase();
            const { error } = await supabase.auth.signInWithPassword({ email: ident.includes('@') ? ident : `${ident}@les-experts.local`, password: mdp });
            setEnvoi(false);
            if (error) toast.error(error.message === 'Invalid login credentials' ? 'Identifiant ou mot de passe incorrect' : `Connexion impossible : ${error.message}`);
          }}>
            <div className="space-y-1.5"><Label htmlFor="email">E-mail ou identifiant</Label><Input id="email" type="text" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} /></div>
            <div className="space-y-1.5"><Label htmlFor="mdp">Mot de passe</Label><Input id="mdp" type="password" autoComplete="current-password" required value={mdp} onChange={(e) => setMdp(e.target.value)} /></div>
            <Button type="submit" className="w-full" disabled={envoi}>Se connecter</Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
